import React from "react";
import SelectableTable from "../SelectableTable/Main.js";
import InputFormTable from "../InputFormTable/Main.js";
import { connect } from "react-redux";
import { linkHeaderAction } from "../../redux/ui/actions";
import { changeSwModeAction } from "../../redux/app/actions";
import Sw from "../common/Sw";

const initData = {
    environment: [
        {
            envType: "river",
            envID: 0,
            envName: "石狩川",
            envPath: "[W05-09_01-g_Stream.shp]",
            envRegion: "北海道",
        },
        {
            envType: "river",
            envID: 1,
            envName: "豊平川",
            envPath: "[W05-09_01-g_Stream.shp]",
            envRegion: "北海道",
        },
    ],
};

class Main extends React.Component {
    constructor(props) {
        console.log("EnvironmentEditor constructor");
        super(props);
        this.state = {
            environment: initData["environment"],
            selected: null,
            mode: "list",
            count: 0,
        };
    }

    /*
     * 環境情報取得
     * environmentフォーマットは
     * initData["environment"]と同じ
     */
    loadEnvironment = async () => {
        const origin = window.location.origin;
        await fetch(`${origin}/api/environment`)
            .then((res) => res.json())
            .then((res) => {
                this.setState({ environment: res });
            })
            .catch((err) => console.log(err));
        console.log("EnvironmentEditor loadEnvironment done");
    };

    async componentDidMount() {
        console.log("EnvironmentEditor componentDidMount");
        await this.loadEnvironment();
    }

    /* 環境情報リスト画面のイベントハンドラ */
    //環境情報新規作成画面へ遷移
    onAdd = (e) => {
        console.log("onAdd");
        this.setState({ mode: "add" });
    };

    //環境情報修正画面へ遷移
    onModify = (e) => {
        console.log("onModify");
        if (this.state.selected) {
            this.setState({ mode: "modify" });
        }
    };

    //環境情報の削除
    onDelete = async (e) => {
        if (!window.confirm("本当に削除しますか?")) {
            return;
        }

        if (!this.state.selected) {
            return;
        }

        const origin = window.location.origin;
        await fetch(`${origin}/api/environment/${this.state.selected.envID}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(this.state.selected),
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({ mode: "list" });
                this.setState({ environment: res });
                this.setState({ selected: null });
            })
            .catch((err) => console.log(err));
    };

    //環境情報の選択
    onEnvCheckedChange = (checked, index) => {
        console.log("onEnvCheckedChange:", checked, index);
        let selected;
        if (checked) {
            selected = this.state.environment[index];
        } else {
            selected = null;
        }

        console.log("onEnvCheckedChange:", JSON.stringify(selected));
        this.setState({ selected: selected });
    };

    /* 地域情報新規作成/修正画面のイベントハンドラ */

    /*
     * 環境情報の追加(POST)/更新(PUT)
     * POST/PUT environmentフォーマット
    {
        envType: "river",
        envID: 0, //使用しない。合ってもなくても良い
        envName: "石狩川",
        envPath: "W05-09_01-g_Stream.shp",
        envRegion: "北海道"
    }
     * POST時はサーバ側で新規にenvIDを生成するため、envIDは指定しない
    */
    onUpdateEnv = async (env) => {
        const origin = window.location.origin;
        console.log("EditEnv:", env);

        let url;
        let method;

        if (this.state.mode == "add") {
            url = `${origin}/api/environment`;
            method = "POST";
        } else if (this.state.mode == "modify") {
            const envID = this.state.selected.envID;
            url = `${origin}/api/environment/${envID}`;
            method = "PUT";
        }

        await fetch(url, {
            method: method,
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(env),
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({ mode: "list" });
                this.setState({ environment: res });
                this.setState({ selected: null });
            })
            .catch((err) => console.log(err));
    };

    //新規追加/修正のキャンセル
    onCancelEdit = () => {
        this.setState({ mode: "list" });
    };

    render() {
        if (this.state.mode == "list") {
            //環境情報リスト画面
            return (
                <div>
                    <SelectableTable key="1" inputType="radio" name="environment" onCheckChange={this.onEnvCheckedChange} dataList={this.state.environment} />
                    <div className="l-row">
                        <button className="sBtn" key="env add" onClick={this.onAdd}>
                            新規
                        </button>
                        <button className="sBtn l-mlS" key="env mod" onClick={this.onModify}>
                            修正
                        </button>
                        <button className="sBtn l-mlS" key="env del" onClick={this.onDelete}>
                            削除
                        </button>
                    </div>
                </div>
            );
        } else {
            //環境情報新規追加/修正画面
            return (
                <Sw title="環境情報追加">
                    <div id="EnvironmentEditor">
                        <InputFormTable
                            onClickOK={this.onUpdateEnv}
                            onClickCancel={this.onCancelEdit}
                            data={this.state.selected ? this.state.selected : { envType: "", envName: "", envPath: "", envRegion: "" }}
                        />
                    </div>
                </Sw>
            );
        }
        return <React.Fragment></React.Fragment>;
    }
}

export default Main;
